import {observer} from 'mobx-react-lite';
import React, {useCallback, useMemo} from 'react';
import {Platform} from 'react-native';

import {lightImpact} from '../../haptics';
import {CarouselScrollView} from '../CarouselScrollView';
import DailyAchievementBinding from './DailyAchievementBinding';
import type {DailyAchievementTabViewProps} from './DailyAchievementTabViewProps';
import TabsContext from './TabsContext';
import useDailyAchievementSlides from './useDailyAchievementSlides';

export default observer(function ActualDailyAchievementTabView(
  props: DailyAchievementTabViewProps,
) {
  const {
    getTabKey,
    setTabKey,
    getIsFocused,
    dailyAchievement,
    accretion,
    ...rest
  } = props;

  const [slides, getIndex, setIndex] = useDailyAchievementSlides(
    dailyAchievement,
    getTabKey,
    setTabKey,
  );

  const slideCount = slides.length;

  const onPress = useCallback(() => {
    setIndex((getIndex() + 1) % slideCount);
  }, [setIndex, getIndex, slideCount]);

  const tabsProps = useMemo(
    () => ({
      accretion,
      onPress,
      onPressIn: Platform.OS === 'ios' ? lightImpactIfPossible : undefined,
    }),
    [accretion, onPress],
  );

  return (
    <TabsContext.Provider value={tabsProps}>
      <CarouselScrollView
        slides={slides}
        SlideComponent={DailyAchievementBinding}
        getIndex={getIndex}
        setIndex={setIndex}
        getIsFocused={getIsFocused}
        {...rest}
      />
    </TabsContext.Provider>
  );
});

function lightImpactIfPossible() {
  lightImpact().catch(() => {});
}
